<template>
  <div class="page-login-v3 layout-full">
    <div class="page vertical-align text-xs-center" >
      <div class="page-content vertical-align-middle">
        <div class="brand">
          <img class="brand-img" src="/static/images/byteark-loading-white.png" alt="logo account" width="180">
          <h2 class="brand-text font-size-24 grey-100"></h2>
        </div>
        <div class="panel">
          <div class="panel-body panel-form">
            <loading-indicator v-if="isLoading"></loading-indicator>
            <div v-else>
              <h3 class="title">{{ $t('account.activate.labels.activateYourAccount') }}</h3>
              <div class="token-invalid" v-if="status == 'link-invalid'">
                <alert alertClass="alert-dismissible" type="danger">
                  <span>{{$t('activate.verifyToken.response.linkInvalid')}}</span>
                </alert>
              </div>
              <div class="token-expried" v-if="status == 'link-expried'">
                <alert alertClass="alert-dismissible" type="danger">
                  <span>{{$t('activate.verifyToken.response.linkExpired')}}</span>
                </alert>
              </div>
              <div v-if="status == 'success'">
                <alert alertClass="alert-dismissible" type="success">
                  <span>{{$t('activate.verifyToken.response.success')}}</span>
                </alert>
                <router-link v-bind:to="`/${this.$route.params.namespace}/login`" class="btn btn-block btn-link btn-lg btn-submit">{{ $t('account.activate.action.login') }}</router-link>
              </div>
            </div>
          </div>
        </div>
        <footer class="page-copyright page-copyright-inverse">
          <p>Service by ByteArk.com</p>
        </footer>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    Alert,
    FormGroup,
    LoadingIndicator,
  },
  data: function() {
    return {
      isLoading: true,
      showAlert: false,
      validator: null,
      status: null, // 'success' , 'link-invalid' , 'link-expired'
      resetPasswordSuccess: false,
      errorResponse: null,
    };
  },
  mounted: function() {
    this.validateToken();
  },
  methods: {
    validateToken: function() {
      const token = this.$route.params.token;
      const namespace = this.$route.params.namespace;

      axios.post(`/api/activate-account`, {
        namespace: namespace,
        token: token,
      })
      .then((response) => {
        this.status = response.data.status;
        this.isLoading = false;
        this.showAlert = true;
      })
      .catch((error) => {
        if (error.response.status === 422) {
          this.status = error.response.data.status;
        } else {
          this.errorResponse = this.$t('recovery.verifyToken.response.defaultFailed');
        }
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.panel-form {
  min-height: 197px;
}
</style>



// WEBPACK FOOTER //
// ActivateAccount.vue?639c0edd